import { CSSProperties, forwardRef, ReactNode } from 'react';
import styled from 'styled-components';

import { blueCharcoal } from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

interface Props {
  readonly children: ReactNode;
  readonly id?: string;
  readonly role?: string;
  readonly className?: string;
  readonly style?: CSSProperties;
}

/**
 * Fill available space and allow content to be scrollable
 */
const FillScrollable = forwardRef<HTMLElement, Props>(function FillScrollable(
  { children, ...props },
  ref,
) {
  return (
    <Scrollable {...props} ref={ref}>
      <Content className="scrollable__content">{children}</Content>
    </Scrollable>
  );
});

export default FillScrollable;

const Scrollable = styled.section`
  position: relative;
  overflow: auto;
  flex: 1;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    background-color: ${blueCharcoal};
  }
`;

const Content = styled.div`
  position: absolute;
  min-width: 100%;
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    max-width: 100%;
  }
`;
